export default __webpack_public_path__ + "static/media/slide5.eeb6471a.png";